export enum YesNoResults {
  Yes = 'Y',
  No = 'N',
}
